<template>
  <main class="group-page-wrap h-100">
    <PageNotFound v-if="pageNotFound"></PageNotFound>
    <div class="container d-flex flex-column h-100" v-else>

      <AddContentToUserGroup :type="'group'" :id="groupId" :name="groupData.title" :img="likeImage" v-if="userGroupAdd" @close="userGroupAdd = false;"></AddContentToUserGroup>

      <div class="row h-100">

        <div class="col-md-7 col-12">
          <Images v-if="showImages" :imageData="imageData"></Images>

  				<Map :mapData="groupMapData" v-else>
            <div class="layer-control-toggle" @click="showLayerControl = !showLayerControl" aria-hidden="true">
              <span class="expand-text">Vælg hvad du vil se på kortet</span>

              <span v-if="isMobile">
                <span class="material-icons expand-icon" aria-hidden="true" v-show="showLayerControl">keyboard_arrow_up</span>
                <span class="material-icons expand-icon" aria-hidden="true" v-show="!showLayerControl">keyboard_arrow_down</span>
              </span>
              <span v-else>
                <span class="material-icons expand-icon" aria-hidden="true" v-show="showLayerControl">keyboard_arrow_down</span>
                <span class="material-icons expand-icon" aria-hidden="true" v-show="!showLayerControl">keyboard_arrow_up</span>
              </span>

              <div class="group-layers" v-show="showLayerControl">
                <div class="group-layers-content">
                  <div style="line-height: 15px; border-bottom: 1px solid #ddd;">
                    Et sted kan være en del af flere temaer. Stedet vises, hvis det er en del af mindst et af de valgte temaer.
                  </div>
                  <div id="layer-toggle-row-all" @click="toggleAllLayers();">
                    <span>Tilvælg/fravælg alt</span>
                    <span class="group-layer-list-checkmark">
                      <span class="material-icons" :class="[selectAllLayers ? 'blue-text' : 'grey-text']" aria-hidden="true">check</span>
                    </span>
                  </div>
                  <template v-for="(layer,index) in listOfLayers">
                    <div class="layer-toggle-row" @click="toggleLayer(layer.layerId);" :key="index">
                      <span class="group-layer-list-icon" v-html="layer.icon"></span>
                      <span>{{ layer.title }}</span>
                      <span class="group-layer-list-checkmark">
                        <span class="material-icons" :class="[layer.active ? 'blue-text' : 'grey-text']" aria-hidden="true">check</span>
                      </span>
                    </div>
                  </template>
                </div>
                <div class="group-layers-content-scroll" v-show="listOfLayers.length > 5">
                  Scroll for flere lag
                </div>
              </div>
            </div>
          </Map>

  				<div class="row group-basic-information-box white-box">
  					<div class="col-12 p-0">
              <Toolbar :type="'group'" :id="groupId" :name="groupData.title" :img="likeImage" :showImages="showImages"  @switchBetweenImageAndMap="showImages = !showImages" @addItemToUserGroup="userGroupAdd = true"></Toolbar>
            </div>

  					<div class="col-12">
  						<h1 class="group-headline d-none d-sm-block" v-if="groupData != false">{{ groupData.title }}</h1>
  					</div>

  					<div class="col-12 group-description">
              <DescriptionBox :descriptionData="groupDescription"></DescriptionBox>
  					</div>
  				</div>

  			</div>

  			<div class="col-lg-5 col-md-5 col-12 group-information-wrap no-pad-both-xs">
  				<div class="col-12 group-information white-box no-pad-both">
  					<ul aria-label="Liste over temaets indhold">
              <template v-for="(child,index) in groupData.children">
                <ThemeChild :childData="child" :tagList="tagList" :searchDataExpanded="searchDataExpanded" :isGroupPage="true" :key="index"></ThemeChild>
              </template>
  					</ul>
  				</div>
  			</div>

      </div>
    </div>
  </main>
</template>

<script>
import DataManager from '@/assets/DataManager.js'
import SearchDataParser from '@/assets/SearchDataParser.js'
import ThemeChild from '@/components/ThemeChild.vue'
import Map from '@/components/map/Map.vue'
import Toolbar from '@/components/Toolbar.vue'
import Images from '@/components/Images.vue'
import MarkerGenerator from '@/assets/MarkerGenerator.js'
import PageSettings from '@/assets/PageSettings.js'
import PageNotFound from '@/components/PageNotFound.vue'
import AddContentToUserGroup from '@/components/profile/AddContentToUserGroup.vue'
import DescriptionBox from '@/components/DescriptionBox.vue'

export default {
  data() {
    return {
      groupData: false,
      groupMapData: [],
      addedItems: [],
      listOfLayers: [],
      showLayerControl: false,
      selectAllLayers: true,
      menuList: {},
      tagList: [],
      searchDataExpanded: [],
      imageData: [],
      likeImage: false,
      showImages: true,
      isMobile: false,
      pageNotFound: false,
      userGroupAdd: false,
      groupDescription: '',
    }
  },
  props: {
    groupId: {
      type: String,
      required: true
    },
    startup: {
      type: String,
    }
  },
  components: {
    ThemeChild, Map, Toolbar, Images, PageNotFound, AddContentToUserGroup, DescriptionBox
  },
  watch: {
    $route(to, from) {
      this.getGroupData();
    }
  },
  beforeCreate() {
    this.$root.$emit('toggleLoadingScreen', true);
  },
  created() {
    this.isMobile = this.$DeviceCheck.isMobile;
    this.getGroupData();
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
  },
  methods: {
    getGroupData() {
      if(this.startup != undefined) {
        this.showImages = (this.startup == 'map' || this.startup == 'mapFull' || this.startup == 'true') ? false : true;
      }
      DataManager.getData([
        DataManager.menuList,
        DataManager.tagList,
        DataManager.searchData,
        DataManager.searchDataExpanded
      ], (response) => {
        this.groupData = false;
        this.imageData = [];
        this.menuList = response[0].data;
        this.tagList = response[1].data;
        this.searchDataExpanded = SearchDataParser(response[2].data, response[3].data).searchDataExpanded;

        for(var i in this.menuList) {
          if(this.menuList[i].id == this.$props.groupId) {
            this.groupData = this.menuList[i];
          }
        }
        let k = 0;
        while(!this.groupData && k <= 20) {
          if(this.menuList[k] == undefined) {
    				break;
    			}
          //console.log(this.menuList[k]);
          this.menuList[k].children.forEach(child => {

            if(child.id == this.$props.groupId) {
              this.groupData = child;
            }
            if(child.type == 'group') {
              if(child.children) {
                child.children.forEach(subChild => {
                  if(subChild.id == this.$props.groupId) {
      							this.groupData = subChild;
      						}
                });
              }
            }
          });
          k++
        }
        if(this.groupData != false) {
          this.getImageData();
          this.getGroupContent();
          this.$HelperFunctions.scrollToTop();
          this.$HelperFunctions.setPageTitle(this.groupData.title);
          let desc = this.groupData.desc.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 200);
          this.groupDescription = this.groupData.desc;
          this.$HelperFunctions.generateMetaTags(this.groupData.title, desc);
        }
        else {
          this.pageNotFound = true;
          this.$root.$emit('toggleLoadingScreen', false);
        }
      });
    },
    getGroupContent() {
      this.listOfLayers = [];
      this.addedItems = [];
      this.checkGroupData(this.groupData);

      this.listOfLayers.sort(function(a, b) {
  			var aName = a.title.toLowerCase();
  			var bName = b.title.toLowerCase();
  			return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
  		});

      this.generateMapContent();
  	},

    checkGroupData(groupData) {
  		if(groupData.children) {
  	    for(var i = 0; i < groupData.children.length; i++) {
          if(groupData.children[i].type == 'tag' && groupData.children[i].tags) {
            this.pushLayerList(groupData.children[i]);
          }
          else if(groupData.children[i].type == 'place') {
            this.pushLayerList(groupData.children[i]);
          }
  	      else if(groupData.children[i].type == 'group') {
  	        this.checkGroupData(groupData.children[i]);
  	      }
  	    }
  		}
    },

  	//Generate layer list
  	pushLayerList(object) {
      var tag;
      var id = object.type == 'place' ? object.primary : object.tags;
      for(var i in this.tagList) {
        if(i == id) {
          tag = this.tagList[i];
          break;
        }
      }
  		if(tag != undefined) {
        var itemId = object.type == 'place' ? object.item_id : tag.id;
        if(this.addedItems.indexOf(itemId) == -1) {
          object.layerId = itemId;
          object.icon = MarkerGenerator.generateListMarker(tag);
          object.active = true;
          for(var i in PageSettings.groupLayerSettings) {
    				if(PageSettings.groupLayerSettings[i].id == this.groupId) {
    					if(object.layerId == PageSettings.groupLayerSettings[i].layerId) {
    						object.active = PageSettings.groupLayerSettings[i].active;
    					}
    				}
    			}
          this.addedItems.push(itemId);
          this.listOfLayers.push(object);
        }
  		}
  	},

    toggleLayer(layerId) {
      this.$root.$emit('toggleLoadingScreen', true);
      for(var i in this.listOfLayers) {
        if(this.listOfLayers[i].layerId == layerId) {
          this.listOfLayers[i].active = !this.listOfLayers[i].active;
          PageSettings.saveGroupLayerSettings(this.groupId, layerId, this.listOfLayers[i].active);
        }
      }
      this.generateMapContent();
    },

    toggleAllLayers() {
      this.$root.$emit('toggleLoadingScreen', true);
      this.selectAllLayers = !this.selectAllLayers;
      var bool = this.selectAllLayers;
      for(var i in this.listOfLayers) {
        this.listOfLayers[i].active = bool;
        PageSettings.saveGroupLayerSettings(this.groupId, this.listOfLayers[i].layerId, this.listOfLayers[i].active);
      }
      this.generateMapContent();
    },

  	generateMapContent() {
      var newMapContent = [];
      var length = this.listOfLayers.length;
      var counter = 0;

      this.listOfLayers.forEach((layer) => {
        if(layer.active) {
          var tag;
          var id = layer.type == 'place' ? layer.primary : layer.tags;
          for(var k in this.tagList) {
            if(k == id) {
              tag = this.tagList[k];
              break;
            }
          }
          DataManager.getData([
            DataManager.newTags+tag.id+'-dk-light.json',
          ], (response) => {
            var tagData = response[0].data;

            if(layer.type == 'tag') {
              for(var item in tagData.features) {
                newMapContent.push(tagData.features[item]);
              }
            }
            else if(layer.type == 'place') {
              var place = tagData.features.find(feature => feature.id == layer.item_id);
              newMapContent.push(place);
            }
            counter++;
          });
        }
        else {
          counter++;
        }
      });

      var checkIfDataReady = setInterval(() => {
        if(counter >= length) {
          this.groupMapData = newMapContent;
          this.$root.$emit('toggleLoadingScreen', false);
          clearInterval(checkIfDataReady)
        }
      }, 500);
				/*for(var i = 0; i < data.features.length; i++) {
					if(data.features[i].geometry.type == 'LineString' && data.features[i].properties.prop105) {
						var startPointMarker = app.generateMarker(data.features[i], [data.features[i].geometry.coordinates[0][1],data.features[i].geometry.coordinates[0][0]], true, true);
						app.generatePopup(data.features[i], startPointMarker, mapVar, tag.id);
					}
				}*/
  	},

    getImageData() {
  		this.$HelperFunctions.checkForHighestResolution(this.groupData.media).then((resolution) => {
        if(this.groupData.media.indexOf('https') == -1) {
    			var imageSrc = this.groupData.media
    		}
    		else {
    			var split = this.groupData.media.split('/');
    			var imageSrc = split[split.length-1];
    		}

    		var imgCredit = (this.groupData.media.photoCredits != undefined && this.groupData.media.photoCredits != '' && this.groupData.media.photoCredits != null && this.groupData.media.photoCredits != 0) ? this.groupData.media.photoCredits : '';
        var options = {resolution: resolution, src: imageSrc, imgCredit: imgCredit, imageName: this.groupData.title};
    		this.imageData.push(options)
        this.likeImage = options.src;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
  .group-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .group-information-wrap {
  	padding-right: 0px;
    height: 100%;
  }

  .group-basic-information-box {
  	margin-top: 10px;
  }

  .group-information {
  	-webkit-overflow-scrolling: touch;
  }

  .group-headline {
    position: relative;
    line-height: 50px;
    font-size: 20px;
    margin: 0px;
  }

  .layer-control-toggle {
  	position: absolute;
  	z-index: 976;
  	height: 40px;
  	padding: 0px;
  	line-height: 40px;
  	background-color: #f8f8f8;
  	cursor: pointer;
  	text-align: center;
    vertical-align: middle;
  }

  .layer-control-toggle span {
  	vertical-align: middle;
  }

  .group-layers {
  	background-color: #f8f8f8;
  	border: 1px solid #ddd;
    z-index: 975;
    text-align: center;
  }

  .group-layers-content {
  	max-height: 203px;
  	overflow-y: auto;
  }

  .group-layers-content-scroll {
  	height: 20px;
  	line-height: 20px;
  	text-align: center;
  	font-size: 13px;
  	border-top: 1px solid #ddd;
  }

  .layer-toggle-row, #layer-toggle-row-all {
  	border-bottom: 1px solid #ddd;
  	position: relative;
  	line-height: 45px;
    cursor: pointer;
  }

  .layer-toggle-row .list-icon {
  	display: inline-block;
  }

  .group-layer-list {
  	display: inline-block;
  	vertical-align: middle;
  }

  .group-layer-list-icon {
  	position: absolute;
  	left: 15px;
    top: 10px;
  }

  .group-layer-list-checkmark {
  	position: absolute;
  	right: 15px;
  }

  .layer-toggle-row:last-child {
    border-bottom: none;
  }

  /*Portrait - XS*/
  @media screen and (max-width: 767px) and (orientation: portrait) {
  	.layer-control-toggle {
  		top: 0px;
  		width: 100%;
  		border: 1px solid #ddd;
  	}
  	.group-description {
  		padding: 10px 5px;
  	}
  	.group-information {
  		height: auto !important;
  	}
  }
  /*Portrait - SM*/
  @media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
  	.layer-control-toggle {
  		bottom: 0px;
  		left: 50%;
  		width: 270px;
  		margin-left: -135px;
  		border: 1px solid #ddd;
  		border-top: 0;
  	}
  	.group-description {
  		padding: 10px 5px 10px 5px;
  	}
  	.group-information {
  		margin-top: 15px;
  		padding-top: 15px;
  		height: auto !important;
  	}
  }
  /*Portrait - MD*/
  @media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {
  	.group-description {
  		padding: 10px 5px 10px 5px;
  	}
  }
  /*Landscape - XS*/
  @media screen and (max-width: 767px) and (orientation: landscape) {
  	.layer-control-toggle {
  		top: 40px;
  		width: 50%;
  	}
  }
  /*Landscape - MD*/
  @media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
  	.layer-control-toggle {
  		bottom: 0px;
  		left: 50%;
  		width: 270px;
  		margin-left: -135px;
  		border: 1px solid #ddd;
  		border-top: 0;
  	}
  	.group-basic-information-box {
  		margin-top: 15px;
  		overflow-y: auto;
  	}
  	.group-information {
  		padding-top: 10px;
  		height: 100%;
  		overflow-y: auto;
  		-webkit-overflow-scrolling: touch;
  	}
  	.group-layers {
  		box-shadow: 0 1px 2px rgba(0,0,0,.1);
  		position: absolute;
      left: 50%;
  		width: 270px;
  		bottom: 37px;
  		margin-left: -1px;
      margin-left: -135px;
  	}
  	.group-description {
  		padding: 10px 15px 0px 15px;
  	}
  }
  /*Landscape - LG*/
  @media screen and (min-width: 1200px) and (orientation: landscape) {
  	.layer-control-toggle {
  		bottom: 0px;
  		left: 50%;
  		width: 270px;
  		margin-left: -135px;
  		border: 1px solid #ddd;
  	}
  	.group-basic-information-box {
  		margin-top: 15px;
  		overflow-y: auto;
  	}
  	.group-information {
  		padding-top: 10px;
  		height: 100%;
  		overflow-y: auto;
  	}
  	.group-layers {
  		position: absolute;
  		width: 270px;
  		bottom: 37px;
      box-shadow: 0 1px 2px rgba(0,0,0,.1);
  		position: absolute;
      left: 50%;
  		width: 270px;
  		bottom: 37px;
  		margin-left: -1px;
      margin-left: -135px;
  	}
  	.group-description {
  		padding: 10px 15px 0px 15px;
  	}
  	.layer-toggle-row:last-child {
  		border-bottom: 2px solid #ddd;
  	}
  }
</style>
